export default {
  "locale": {
    "label": "语言",
    "switchSuccess": "语言已切换",
    "zhCN": "简体中文",
    "zhTW": "繁體中文",
    "en": "English"
  },
  "login": {
    "welcome": "欢迎使用",
    "title": "充电桩商户管理平台",
    "usernamePlaceholder": "请输入用户名",
    "passwordPlaceholder": "密码",
    "captchaPlaceholder": "验证码",
    "loginBtn": "登录",
    "agreePrefix": "我已阅读并同意 ",
    "userAgreement": "用户协议",
    "accountLogin": "账户登录",
    "usernameRequired": "用户名不能为空!",
    "passwordRequired": "密码不能为空",
    "agreementRequired": "请同意用户协议",
    "loginSuccess": "登录成功",
    "fetchUserInfoFailed": "获取用户信息失败，请重试"
  },
  "error":{
    "wechatTip": "请您在微信浏览器中打开",
  },
  "advert": {
    "title": "广告标题",
    "url": "链接",
    "showPage": "展示位置",
    "uploadImage": "上传图片",
    "showPage_tip_1": "扫码成功",
    "showPage_tip_2": "充电开始",
    "showPage_tip_3": "问题反馈",
    "showPage_tip_4": "订单列表",
    "uploadImageTip_1": "上传图片只能是 JPG 格式!",
    "uploadImageTip_2": "上传图片大小不能超过 2MB!",
    "success": "修改成功",
    "addSuccess": "添加成功",
    "deleteSuccess": "删除成功",
    "noData": "暂无广告记录",
    "addNotice": "新增广告",
    "siteName": "站点名称",
  },
  "card": {
    "cardNo": "卡号",
    "physicalCardNo": "物理卡号",
    "sum": "余额",
    "mobile": "手机号",
    "realName": "代理商",
    "save": "保存",
    "selectOperator": "请选择代理商",
    "inputCardNo": "请输入卡号",
    "inputPhysicalCardNo": "请输入物理卡号",
    "inputSum": "请输入余额",
    "inputMobile": "请输入手机号",
    "cardNoError": "请输入卡号(ABCDEF)+数字(0-9)",
    "inputTip":"请输入",
    "inputLegalAmount":"请输入合法金额",
    "inputPhone":"请输入正确的手机号",
    "editCard": "编辑卡",
    "addCard": "新增卡",
    "addCardFailed": "新增卡失败",
    "editCardFailed": "编辑卡失败",
    "card_1":"请输入卡号/手机号",
    "card_2":"暂时没有IC卡",
    "card_3":"请点击右侧 ’添加‘ 按钮",
    "card_4":"开始您的运营之旅吧！",
    "card_5":"添加",
    "card_6":"全部卡",
    "card_7":"卡号：",
    "card_8":"用户手机号",
    "card_9":"卡余额",
    "card_10":"绑定日期",
    "card_11":"挂失",
    "card_12":"充值记录",
    "card_13":"使用记录",
    "card_14":"您是否确定要对该卡片进行挂失处理？",
    "card_15":"我再想想",
    "card_16":"未知",
    "card_17":"暂无",
    "card_18":"已加载全部数据",
    "card_19":"暂无数据",
    "card_20":"获取数据失败",
    "card_21":"当前卡片已挂失",
    "card_22":"挂失成功",
    "card_23":"挂失失败",
    "card_24":"新建",
    "card_25":"筛选",
    "card_26":"用户名",
    "card_27":"未绑定",
    "card_28":"电话",
    "card_29":"无",
    "card_30":"状态",
    "card_31":"暂无卡片",
    "card_32":"正常",
    "card_33":"已挂失",
    "card_34":"未启用",
    "card_35":"添加卡",
    "card_36":"卡编",
    "card_37":"请输入号码",
    "card_38":"卡号不能为空",
    "card_39":"余额不能为空",
    "card_40":"手机号不能为空",
    "card_41":"手机号码有误，请重填",
    "card_42":"确定要挂失此卡？",
    "card_43":"取消挂失",
    "card_44":"搜索卡号/手机号",
    "card_45":"操作",
    "card_46":"时间",
    "card_47":"暂无更多",
    "card_48":"",
    "card_49":"卡编号: ",
    "card_50":"暂无充值记录",
    "card_51":"充值 ",
    "card_52":"消费",
    "card_53":"赠送",
    "card_54":"系统充值",
    "card_55":"退款",
    "card_56":"退款失败",
    "card_57":"转款",
    "card_58":"金额",
    "card_59":"日期",
    "card_60":"实际时间",
    "card_61":"预计时间",
    "card_62":"充电桩编号",
    "card_63":"暂无使用记录",
    "card_64":"卡号必须为数字!",
    "card_65":"到底了",
    "card_66":"更多",
    "card_67":"查看",
    "card_68":"充值",
    "card_69":"绑定用户",
    "card_70":"解绑用户",
    "card_71":"补卡",
    "card_72":"卡详情",
    "card_73":"充值金额",
    "card_74":"请输入充值金额",
    "card_75":"充值成功",
    "card_76":"充值失败",
    "card_77":"新卡号",
    "card_78":"请输入新卡号",
    "card_79":"补卡成功",
    "card_80":"补卡失败",
    "card_81":"确定要删除该卡？",
    "card_82":"删除成功",
    "card_83":"删除失败",
    "card_84":"确定要解绑该用户？",
    "card_85":"解绑成功",
    "card_86":"解绑失败",
    "card_87":"取消挂失成功",
    "card_88":"取消挂失失败",
    "card_89":"绑定成功",
    "card_90":"绑定失败",
  },
  "equip": {
    "equip_1": "您还没有添加设备",
    "equip_2": "请点击下方 ’添加设备‘ 按钮",
    "equip_3": "全部设备",
    "equip_4": "运行",
    "equip_5": "离线",
    "equip_6": "总收益",
    "equip_7": "已充电量",
    "equip_8": "充电次数",
    "equip_9": "充电时长",
    "equip_10": "规则设置",
    "equip_11": "选择规则",
    "equip_12": "请选择规则",
    "equip_13": "编辑",
    "equip_14": "全部",
    "equip_15": "端口管理",
    "equip_16": "规则管理",
    "equip_17": "查看收益",
    "equip_18": "编辑",
    "equip_19": "新增设备",
    "equip_20": "小区名称/设备编号",
    "equip_21": "台",
    "equip_22": "充电桩编号",
    "equip_23": "暂无设备",
    "equip_24": "充电桩编码",
    "equip_25": "充电桩名称",
    "equip_26": "充电桩类型",
    "equip_27": "枪口数量",
    "equip_28": "电流（A）",
    "equip_29": "电压（V）",
    "equip_30": "功率（kW）",
    "equip_31": "sim卡序列号",
    "equip_32": "sim卡到期时间",
    "equip_33": "请选择",
    "equip_34": "站点",
    "equip_35": "保存",
    "equip_portType": "枪口类型",
    "equip_portType_1": "单枪",
    "equip_portType_2": "双枪",
    "equip_portType_8": "一拖八",
    "equip_portType_10": "一拖十",
    "equip_portType_16": "一拖十六",
    "equip_portType_tip": "请选择枪口类型",
    "equip_supply": "厂商设备型号",
    "equip_supply_tip": "请选择厂商设备型号",
    "equip_cpFeeType": "计费类型",
    "equip_cpFeeType_charge": "收费",
    "equip_cpFeeType_free": "免费",
    "equip_protocolType": "协议类型",
    "equip_protocolType_tip": "请选择协议类型",
    "equip_36": "请选择时间日期",
    "equip_37": "请输入正确的数值",
    "equip_38": "请输入充电桩编号",
    "equip_39": "电桩编号限制14位数字",
    "equip_40": "请输入电流",
    "equip_41": "请输入电压",
    "equip_42": "请输入最大功率",
    "equip_43": "请输入充电桩名称",
    "equip_44": "请输入端口数量",
    "equip_45": "请选择充电桩类型",
    "equip_46": "请选择状态",
    "equip_48": "请选择站点",
    "equip_49": "设备编辑",
    "equip_50": "保存成功",
    "equip_51": "保存失败",
    "equip_52": "接口异常",
    "equip_53": "慢充",
    "equip_54": "快充",
    "equip_pileType_0": "中充(3.5kW-7kW)",
    "equip_pileType_1": "快充(11-22kW)",
    "equip_pileType_2": "特快充(40-60kW)",
    "equip_pileType_3": "超快充(120kW)",
    "equip_55": "禁用",
    "equip_56": "启用",
    "equip_pileAccess": "桩访问属性",
    "equip_pileAccess_0": "公用设备",
    "equip_pileAccess_1": "固定设备",
    "equip_pileAccess_tip": "请选择桩访问属性",
    "equip_57": "设备编号",
    "equip_58": "设备名称",
    "equip_59": "sim卡",
    "equip_60": "投放地址",
    "equip_61": "省",
    "equip_62": "市",
    "equip_63": "区",
    "equip_64": "详细小区",
    "equip_65": "设备类型",
    "equip_66": "运行状态",
    "equip_67": "请选择地区",
    "equip_68": "请选择小区",
    "equip_69": "请选择收费类型",
    "equip_70": "请选择运行状态",
    "equip_71": "暂无该地区小区数据",
    "equip_72": "输入自定义小区",
    "equip_73": "请输入正确充电桩编号",
    "equip_74": "请输入充电桩名",
    "equip_75": "请选择充电桩所在小区",
    "equip_76": "请选择充电桩收费类型",
    "equip_77": "总收益(HKD)",
    "equip_78": "已充电量(度)",
    "equip_79": "充电时长(小时)",
    "equip_80": "编辑端口",
    "equip_81": "编辑名称",
    "equip_82": "端口状态",
    "equip_83": "请选择端口状态",
    "equip_84": "离线",
    "equip_85": "故障",
    "equip_86": "空闲",
    "equip_87": "充电",
    "equip_88": "已插枪",
    "equip_89": "占用",
    "equip_90": "操作成功",
    "equip_91": "操作失败",
    "equip_92": "此端口正在使用无法编辑",
    "equip_93": "请填写端口名称",
    "equip_94": "编辑端口成功",
    "equip_95": "总耗电量",
    "equip_96": "暂无时间",
    "equip_97": "暂无端口",
    "equip_98": "添加端口",
    "equip_99": "端口名称",
    "equip_100": "请输入端口名称",
    "equip_101": "使用",
    "equip_102": "删除端口成功",
    "equip_103": "公众号规则",
    "equip_104": "去编辑选中规则",
    "equip_105": "卡规则",
    "equip_106": "请选择公众号规则",
    "equip_107": "请选择卡规则",
    "equip_108": "请先选择规则",
    "equip_109": "请选择公众规则",
    "equip_110": "设置规则成功",
    "equip_111": "在线",
    "equip_112": "离线",
    "equip_113": "已耗电量",
    "equip_114": "度",
    "equip_115": "电费",
    "equip_116": "服务费",
    "equip_117": "小时",
    "equip_118": "规则名称",
    "equip_119": "充电桩限制8位数字",
    "equip_120": "电流",
    "equip_121": "电压",
    "equip_122": "最大功率",
    "equip_123": "编辑保存",
    "equip_124": "立即添加",
    "equip_125": "请输入数字",
    "equip_126": "请输入卡序号",
    "equip_127": "请选择到期时间",
    "equip_128": "开启",
    "equip_129": "关闭",
    "equip_130": "添加端口成功",
    "equip_131": "设备总收益",
  },
  "equipment":{
    "equipment_1": "收益情况",
    "equipment_2": "合计(HKD)",
    "equipment_3": "暂无记录",
    "equipment_4": "请输入订单号",
    "equipment_5": "收益",
    "equipment_6": "收益总额",
    "equipment_7": "订单数量",
    "equipment_8": "单号",
    "equipment_9": "开始时间",
    "equipment_10": "结束时间",
    "equipment_11": "暂无订单记录",
    "equipment_12": "我的收益",
    "equipment_13": "用户消费",
    "equipment_14": "全部",
    "equipment_15": "消耗电量",
    "equipment_16": "退费金额",
    "equipment_17": "消费纸巾包",
    "equipment_18": "刷卡消费额",
    "equipment_19": "使用时长",
    "equipment_20": "消费金额",
    "equipment_21": "实际消费",
    "equipment_22": "线下投币",
    "equipment_23": "充值卡",
    "equipment_24": "广告",
    "equipment_25": "充值",
    "equipment_26": "账户余额",
    "equipment_27": "立即提现",
    "equipment_28": "数据看板",
    "equipment_29": "本月收益",
    "equipment_30": "今日收益",
    "equipment_31": "完成订单",
    "equipment_32": "设备总数",
    "equipment_33": "设备总耗电量",
    "equipment_34": "账单明细",
    "equipment_35": "地址统计",
    "equipment_36": "时间统计",
    "equipment_37": "本月总收益",
    "equipment_38": "在线支付",
    "equipment_39": "卡支付",
    "equipment_40": "线上",
    "equipment_41": "线下",
  },
  "mine":{
    "mine_1": "常用功能",
    "mine_2": "经营数据",
    "mine_3": "全部电站",
    "mine_4": "全部时间",
    "mine_5": "清空",
    "mine_6": "全部收益",
    "mine_7": "总收益",
    "mine_8": "电费",
    "mine_9": "服务费",
    "mine_10": "运行",
    "mine_11": "离线",
    "mine_12": "总交易额",
    "mine_13": "电费",
    "mine_14": "服务费",
    "mine_15": "充电量(度)",
    "mine_16": "充电次数",
    "mine_17": "站点管理",
    "mine_18": "设备管理",
    "mine_19": "订单管理",
    "mine_20": "IC卡管理",
    "mine_21": "规则管理",
    "mine_22": "用户管理",
    "mine_23": "问题反馈",
    "mine_24": "分成汇总",
    "mine_25": "小区管理",
    "mine_26": "电卡管理",
    "mine_27": "提现记录",
    "mine_28": "当前余额(HKD)",
    "mine_29": "可提现余额(HKD)",
    "mine_30": "平台冻结金额(HKD)",
    "mine_31": "提现账户",
    "mine_32": "提现金额",
    "mine_33": "全部提现",
    "mine_34": "最低提现金额",
    "mine_35": "本次提现手续费",
    "mine_36": "自动提现",
    "mine_37": "是",
    "mine_38": "最低收取",
    "mine_39": "手续费",
    "mine_40": "上传发票",
    "mine_41": "仅支持pdf，单个文件不超过500KB，最多3个",
    "mine_42": "提现",
    "mine_43": "提现提醒",
    "mine_44": "实际到账",
    "mine_45": "确认提现",
    "mine_46": "我再想想",
    "mine_47": "提现金额必须大于0",
    "mine_48": "提现金额最多保留两位小数",
    "mine_49": "提现金额不能大于可提现余额",
    "mine_50": "提现金额不能小于最低提现金额",
    "mine_51": "实际到账{actual_money}， 手续费{transFree}",
    "mine_52": "正在提现中",
    "mine_53": "最多只能上传3个发票",
    "mine_54": "仅支持PDF文件",
    "mine_55": "文件大小不能超过500KB",
    "mine_56": "上传中...",
    "mine_57": "上传失败",
    "mine_58": "您所属的运营商没有正确配置公众号信息",
    "mine_59": "绑定成功",
    "mine_60": "欢迎回来，",
    "mine_61": "进入工作台",
    "mine_62": "创建时间",
    "mine_63": "单车",
    "mine_64": "汽车",
    "mine_65": "累计收益",
    "mine_66": "今日收益",
    "mine_67": "账户余额",
    "mine_68": "去提现",
    "mine_69": "本月收益",
    "mine_70": "经营数据",
    "mine_71": "经营金额",
    "mine_72": "",
    "mine_73": "订单总金额",
    "mine_74": "我的分成金额",
    "mine_75": "查看分成明细",
    "mine_76": "分成统计",
    "mine_77": "累计金额",
    "mine_78": "近一周",
    "mine_79": "近一月",
    "mine_80": "近一年",
    "mine_81": "累计电量(度)",
    "mine_82": "退款金额",
    "mine_83": "订单数",
    "mine_84": "注册用户(人)",
    "mine_85": "金额",
    "mine_86": "运行设备",
    "mine_87": "离线设备",
    "mine_88": "当前可提现余额为0，无法提现",
    "mine_89": "充值金额",
    "mine_90": "退款金额",
    "mine_91": "退款金额",
    "mine_92": "订单总数(单)",
    "mine_93": "设备状态",
    "mine_94": "站点总数",
    "mine_95": "设备统计",
    "mine_96": "查看更多",
    "mine_97": "销售总额",
    "mine_98": "退款总额",
    "mine_99": "退款订单数",
    "mine_100": "订单数",
    "mine_101": "有效订单数",
    "mine_102": "订单总收益(HKD)",
    "mine_103": "分成总收益(HKD)",
    "mine_104": "累计电费(HKD)",
    "mine_105": "累计服务费(HKD)",
    "mine_106": "设备总数(台)",
    "mine_107": "端口数量(台)",
    "mine_108": "订单数(单)",
    "mine_109": "累计充电量(度)",
    "mine_110": "销售统计",
    "mine_111": "设备统计",
    "mine_112": "金额(HKD)",
    "mine_113": "耗电量(度)",
    "mine_114": "使用率",
    "mine_115": "有效端口",
    "mine_116": "损坏端口",
    "mine_117": "近一季",
    "mine_118": "用户",
    "mine_119": "电站名称",
    "mine_120": "订单号",
    "mine_121": "订单金额",
    "mine_122": "本次分成金额",
    "mine_123": "暂无分成记录",
    "mine_124": "天",
    "mine_125": "小时",
    "mine_126": "分",
    "mine_127": "提现单号",
    "mine_128": "提现日期",
    "mine_129": "提现金额",
    "mine_130": "实际到账金额",
    "mine_131": "提现状态",
    "mine_132": "未审批",
    "mine_133": "过程中",
    "mine_134": "成功",
    "mine_135": "失败",
    "mine_136": "-提现记录",
    "mine_137": "退出登录",
    "mine_138": "提现记录",
    "mine_139": "是否确定退出当前账号？",
    "mine_140": "正在退出",
    "mine_141": "订单总金额",
    "mine_142": "我的分成金额",
    "mine_143": "总充电费",
    "mine_144": "总服务费",
    "mine_145": "旧密码",
    "mine_146": "新密码",
    "mine_147": "确认新密码",
    "mine_148": "两次输入的密码不正确",
    "mine_149": "请填写旧密码",
    "mine_150": "请填写新密码",
    "mine_151": "请填写确认新密码",
    "mine_152": "密码修改成功",
    "mine_153": "密码修改失败",
    "mine_154": "请输入提现金额",
    "mine_155": "已绑定微信",
    "mine_156": "实时到账",
    "mine_157": "提现成功",
    "mine_158": "IC卡",
    "mine_159": "请选择卡号",
    "mine_160": "转账金额",
    "mine_161": "请输入金额",
    "mine_162": "账户余额",
    "mine_163": "请输入非负数字",
    "mine_164": "可转账金额不得超过",
    "mine_165": "转账成功",
    "mine_166": "转账失败",
    "mine_167": "退款记录",
    "mine_168": "暂无用户",
    "mine_169": "全部用户",
    "mine_170": "注册时间",
    "mine_171": "累计充值",
    "mine_172": "卡余额",
    "mine_173": "转账",
    "mine_174": "可转账金额",
    "mine_175": "此用户未拥有储值卡，无法转账",
    "mine_176": "请输入用户昵称或者手机号",
    "mine_177": "余额数",
    "mine_178": "累计充值(HKD)",
    "mine_179": "余额(HKD)",
    "mine_180": "卡余额(HKD)",
  },
  "order":{
    "order_1": "暂无订单数据",
    "order_2": "全部订单",
    "order_3": "订单编号",
    "order_4": "预计结束时间",
    "order_5": "充电金额",
    "order_6": "支付状态",
    "order_7": "订单信息",
    "order_8": "订单类型",
    "order_9": "退款金额不能大于订单金额",
    "order_10": "请输入退款金额",
    "order_11": "订单状态跟踪",
    "order_12": "团体订单",
    "order_13": "否",
    "order_14": "费用信息",
    "order_15": "电费成本费用",
    "order_16": "优惠券优惠金额",
    "order_17": "站点优惠金额",
    "order_18": "电费优惠总金额",
    "order_19": "服务费优惠总金额",
    "order_20": "积分信息",
    "order_21": "充电积分",
    "order_22": "停车积分",
    "order_23": "抵扣积分",
    "order_24": "抵扣金额",
    "order_25": "满积分服务费优惠金额",
    "order_26": "设备信息",
    "order_27": "电站位置",
    "order_28": "用户信息",
    "order_29": "支付信息",
    "order_30": "支付方式",
    "order_31": "线上支付",
    "order_32": "支付时间",
    "order_33": "申请退款",
    "order_34": "下单",
    "order_35": "支付成功",
    "order_36": "完成",
    "order_37": "结算中",
    "order_38": "手动结算",
    "order_39": "实际支付金额",
    "order_40": "按时间查询",
    "order_41": "当日查询：按小时显示数据；",
    "order_42": "天数查询：按天显示数据；",
    "order_43": "请选择开始日期",
    "order_44": "请选择结束日期",
    "order_45": "订单数",
    "order_46": "销售额",
    "order_47": "结束时间不能小于开始时间",
    "order_48": "至",
    "order_49": "端口号",
    "order_50": "请输入充电桩端口号",
    "order_51": "电量",
    "order_52": "时长",
    "order_53": "端口变更",
    "order_54": "订单状态",
    "order_55": "地址",
    "order_56": "端口",
    "order_57": "实际充电时长",
  },
  "inuseorderdetial": {
    "briefPlaceOrder": "客户下单",
    "briefStartCharge": "开始充电",
    "briefCharging": "充电中",
    "briefEndCharge": "结束充电",
    "briefChargeTerminated": "充电终止",
    "briefSettling": "结算中",
    "briefCompleteOrder": "完成订单",
    "traceClientRemoteStart": "通过用户端，远程启动充电",
    "traceRemoteStart": "远程启动充电",
    "traceRemoteStartSuccess": "远程启动充电成功，开始充电",
    "traceCharging": "充电中",
    "traceManualStop": "用户手动结束了充电",
    "traceRemoteStop": "远程停止",
    "traceStopped": "停止充电",
    "traceSettling": "订单结算中",
    "traceConsumptionSuccess": "消费成功，本次消费{amount}，账户余额：{balance}",
    "traceCompleted": "订单已完成"
  },
  "promotion":{
    "promotion_1": "促销名称",
    "promotion_2": "满足金额",
    "promotion_3": "赠送金额",
    "promotion_4": "状态",
    "promotion_5": "是否显示",
    "promotion_6": "正常",
    "promotion_7": "禁用",
    "promotion_8": "不显示",
    "promotion_9": "显示",
    "promotion_10": "请将信息填写完整后提交",
    "promotion_11": "修改成功",
    "promotion_12": "添加成功",
    "promotion_13": "新增促销",
    "promotion_14": "促销满足金额",
    "promotion_15": "赠送金额",
    "promotion_16": "创建时间",
    "promotion_17": "",
    "promotion_18": "",
    "promotion_19": "",
    "promotion_20": "",
    "promotion_21": "",
    "promotion_22": "",
    "promotion_23": "",
    "promotion_24": "",
    "promotion_25": "",
    "promotion_26": "",
    "promotion_27": "",
    "promotion_28": "",
    "promotion_29": "",
    "promotion_30": "",
    "promotion_31": "",
    "promotion_32": "",
    "promotion_33": "",
    "promotion_34": "",
    "promotion_35": "",
    "promotion_36": "",
    "promotion_37": "",
    "promotion_38": "",


  },
  "response":{
    "response_1": "用户昵称",
    "response_2": "联系电话",
    "response_3": "问题类型",
    "response_4": "问题描述",
    "response_5": "提交时间",
    "response_6": "设备名称",
    "response_7": "设备编号",
    "response_8": "端口号",
    "response_9": "批注",
    "response_10": "处理人",
    "response_11": "处理时间",
    "response_12": "填写批注",
    "response_13": "请输入批注",
    "response_14": "批注成功",
    "response_15": "暂时没有问题反馈",
    "response_16": "全部反馈",
    "response_17": "待反馈",
    "response_18": "其他原因",
    "response_19": "用户手机号",
    "response_20": "设备名称",
    "response_21": "充电桩编码",
    "response_22": "问题描述",
    "response_23": "暂无反馈记录",
    "response_24": "反馈状态",
    "response_25": "反馈类型",
    "response_26": "请选择反馈状态",
    "response_27": "请选择反馈类型",
    "response_28": "处理完成",
    "response_29": "未处理",
    "response_30": "桩编码",
    "response_31": "端口号",
    "response_32": "其他类型",
    "response_33": "反馈时间",
    "response_34": "处理信息",
    "response_35": "处理批注",
    "response_36": "提交成功",
  },
  "rules":{
    "rules_1": "规则名称",
    "rules_2": "请输入计费规则名称",
    "rules_3": "费用设置",
    "rules_4": "注：峰、平、谷时段价格均为必填项。因各地电价不同，请根据当地实际 电价填写。",
    "rules_5": "电费（HKD/度）",
    "rules_6": "服务费（HKD/度）",
    "rules_7": "24小时尖峰平谷分布设置",
    "rules_8": "注：时间设置最小间隔为30分钟；最多可设置48个计费时段。",
    "rules_9": "时段",
    "rules_10": "费用类型",
    "rules_11": "添加",
    "rules_12": "档位显示方式",
    "rules_13": "充电车主选择支付金额的页面",
    "rules_14": "是否开启智能充满",
    "rules_15": "时长",
    "rules_16": "金额",
    "rules_17": "电量",
    "rules_18": "选择时间",
    "rules_19": "尖时段",
    "rules_20": "峰时段",
    "rules_21": "平时段",
    "rules_22": "谷时段",
    "rules_23": "请输入必填项",
    "rules_24": "开始时间和截止时间不能相同",
    "rules_25": "开始时间不能小于结束时间",
    "rules_26": "时间必须连续",
    "rules_27": "最多只能设置48个时间段哦",
    "rules_28": "时长(h)",
    "rules_29": "费用(HKD)",
    "rules_30": "单价/h",
    "rules_31": "类型",
    "rules_32": "收费类型",
    "rules_33": "创建时间",
    "rules_34": "暂无规则价格记录",
    "rules_35": "新建规则价格",
    "rules_36": "计费类型",
    "rules_37": "请输入计费类型",
    "rules_38": "固定",
    "rules_39": "请输入类型",
    "rules_40": "时长",
    "rules_41": "请输入时长",
    "rules_42": "请输入单价",
    "rules_43": "请输入费用",
    "rules_44": "超出时间",
    "rules_45": "规则大于某值",
    "rules_46": "超出价格",
    "rules_47": "规则大于某值时价格",
    "rules_48": "请选择计费类型",
    "rules_49": "请选择类型",
    "rules_50": "编辑规则价格",
    "rules_51": "自定义时长",
    "rules_52": "复制该规则？",
    "rules_53": "复制价格成功",
    "rules_54": "取消复制",
    "rules_55": "添加价格成功",
    "rules_56": "修改价格成功",
    "rules_57": "确定要删除？",
    "rules_58": "删除成功",
    "rules_59": "取消删除",
    "rules_60": "小时计费",
    "rules_61": "暂时没有规则数据",
    "rules_62": "全部规则",
    "rules_63": "应用设备",
    "rules_64": "复制",
    "rules_65": "复制规则",
    "rules_66": "您是否确定要删除该计费规则？",
    "rules_67": "我再想想",
    "rules_68": "请输入规则名称",
    "rules_69": "复制规则成功",
    "rules_70": "请输入规则名称",
    "rules_71": "复制规则失败",
    "rules_72": "取消复制规则",
    "rules_73": "确认删除？",
    "rules_74": "删除失败",
    "rules_75": "请输入规则",
    "rules_76": "默认规则",
    "rules_77": "暂无规则",
    "rules_78": "请输入新规则名",
    "rules_79": "规则名不能为空",
    "rules_80": "规则设置",
    "rules_81": "新增规则",
    "rules_82": "设置规则成功",
    "rules_83": "规则编辑",
    "rules_84": "添加价格失败",
    "rules_85": "请输入时长为数字",
    "rules_86": "请输入单价为数字",
    "rules_87": "修改价格失败",
    "rules_88": "站点名",
    "rules_89": "供应商",
    "rules_90": "用户充电时长配置",
    "rules_91": "用户选择充电时长配置",
    "rules_92": "+添加时长",
    "rules_93": "计费配置",
    "rules_94": "按小时计费",
    "rules_95": "按电量计费",
    "rules_96": "按功率计费",
    "rules_97": "不限功率",
    "rules_98": "功率段",
    "rules_99": "金额",
    "rules_100": "HKD/小时",
    "rules_101": "服务费设置",
    "rules_102": "HKD/度",
    "rules_103": "收费说明：实际使用电量*（电费+服务费）",
    "rules_104": "+添加功率",
    "rules_105": "收费模式",
    "rules_106": "编辑规则失败",
    "rules_107": "成本（HKD/度）",
    "rules_108": "成本电费应小于等于对应的电费金额",
  },
  "site":{
    "site_1": "站点名称",
    "site_plotNature": "场站属性",
    "site_plotNature_1": "公共",
    "site_plotNature_2": "工作场所",
    "site_plotNature_3": "住宅",
    "site_agent": "所属代理商",
    "site_agent_placeholder": "请选择所属代理商",
    "site_2": "请输入站点名称",
    "site_3": "所属地区",
    "site_4": "省/市/区",
    "site_5": "位置选择",
    "site_6": "选择位置",
    "site_7": "站点图片",
    "site_8": "停车信息",
    "site_9": "停车收费类型",
    "site_10": "停车收费",
    "site_11": "停车免费",
    "site_12": "是否支持开收据",
    "site_13": "不支持",
    "site_14": "支持",
    "site_15": "配套设施",
    "site_16": "免费WIFI",
    "site_17": "便利店",
    "site_18": "洗车",
    "site_19": "厕所",
    "site_20": "负责人",
    "site_21": "请输入负责人",
    "site_22": "联系电话",
    "site_23": "请输入11位手机号",
    "site_24": "是否支持即插即充",
    "site_25": "不支持",
    "site_26": "支持",
    "site_27": "运营状态",
    "site_28": "停业",
    "site_29": "在营",
    "site_30": "站点运营时间",
    "site_31": "开始时间",
    "site_32": "结束时间",
    "site_33": "应用是否显示",
    "site_34": "隐藏",
    "site_35": "显示",
    "site_36": "选择地区",
    "site_37": "请选择时间",
    "site_38": "相册",
    "site_39": "请输入站点名称",
    "site_40": "长度在 3 到 10 个字符",
    "site_41": "暂无功能",
    "site_42": "上传失败",
    "site_43": "上传图片只能是 JPG / PNG格式!",
    "site_44": "上传图片大小不能超过 2MB!",
    "site_45": "请将信息填写完整后提交",
    "site_46": "请输入11位手机号",
    "site_47": "请输入正确的手机号格式",
    "site_48": "修改成功",
    "site_49": "添加成功",
    "site_50": "添加失败",
    "site_51": "您还没有添加充电站",
    "site_52": "请点击下方 ’添加充电站‘ 按钮",
    "site_53": "开始您的运营之旅吧！",
    "site_54": "全部站点",
    "site_55": "位置",
    "site_56": "搜索地点",
    "site_57": "北京市政府",
    "site_58": "基本信息",
    "site_59": "小区名称",
    "site_60": "详细地址",
    "site_61": "请输入详细地址",
    "site_62": "添加图片",
    "site_63": "请输入小区名称",
    "site_64": "全部小区",
    "site_65": "新增小区",
    "site_66": "站点编号",
    "site_67": "启用积分抵现",
    "site_68": "启用及时驶离赠送积分",
    "site_69": "启用充电赠送积分",
    "site_70": "请输入站点编号",
    "site_71": "是",
    "site_72": "否",
    "site_73": "请输入手机号",
    "site_74": "",
    "site_75": "",
    "site_76": "",
    "site_77": "占桩费设置",
    "site_78": "分成设置",
    "site_79": "是否开启占桩费",
    "site_80": "免费占用时长",
    "site_81": "收费单价",
    "site_82": "封顶金额",
    "site_83": "分钟",
    "site_84": "HKD/分钟",
    "site_85": "",
    "site_86": "请输入免费占用时长",
    "site_87": "请输入收费单价",
    "site_88": "请输入封顶金额",
    "site_89": "占桩费设置成功",
    "site_90": "占桩费设置失败",
    "site_91": "获取占桩费配置失败",
    "site_92": "站点分成设置",
    "site_93": "代理商名称",
    "site_94": "分成方式",
    "site_95": "请选择分成方式",
    "site_96": "代理商分成比例(%)",
    "site_97": "平台分成比例(%)",
    "site_98": "电费",
    "site_99": "服务费",
    "site_100": "电费+服务费",
    "site_101": "分成方式设置成功",
    "site_102": "分成方式设置失败",
    "site_103": "收款人",
    "site_104": "电费利润分成比例(%)",
    "site_105": "成本电费分成比例(%)",
    "site_106": "服务费分成比例(%)",
    "site_107": "备注",
    "site_108": "电费利润分成比例总和不等于100",
    "site_109": "成本电费分成比例总和不等于100",
    "site_110": "服务费分成比例总和不等于100",
    "site_111": "请输入代理商分成比例",
    "site_112": "自动计算",
    "site_113": "温馨提示1：分成比例仅需填写整数（如：想分60%给某个用户则填“60”）；若不需分成给第三方人员，请设置100%给站点归属方。",
    "site_114": "温馨提示2：所有分成比例的总和必须等于100。",
    "site_115": "温馨提示3：电费利润=电费-成本电费；",
    "site_116": "HKD",

  },
  "admin":{
    "admin_1": "首页",
    "admin_2": "我的",
    "admin_3": "经营管理",
    "admin_4": "您所属的运营商没有正确配置公众号信息",
    "admin_5": "分成明细",
    "admin_6": "订单列表",
    "admin_7": "订单详情",
    "admin_8": "退款",
    "admin_9": "订单编辑",
    "admin_10": "查看收益",
    "admin_11": "卡管理",
    "admin_12": "卡充值记录",
    "admin_13": "卡使用记录",
    "admin_14": "反馈管理",
    "admin_15": "反馈详情",
    "admin_16": "余额详情",
    "admin_17": "绑定微信",
    "admin_18": "账号设置",
    "admin_19": "语言",
    "admin_20": "提现记录",
    "admin_21": "设备管理",
    "admin_22": "设备编辑",
    "admin_23": "设备添加",
    "admin_24": "设备端口",
    "admin_25": "用户管理",
    "admin_26": "转账",
    "admin_27": "规则管理",
    "admin_28": "选择规则",
    "admin_29": "规则编辑",
    "admin_30": "站点管理",
    "admin_31": "小区管理",
    "admin_32": "站点新增/编辑",
    "admin_33": "广告管理",
    "admin_34": "广告新增/编辑",
    "admin_35": "促销管理",
    "admin_36": "促销新增/编辑",
    "admin_37": "提现",
    "admin_38": "用户充值记录",
    "admin_39": "卡新增/编辑",
    "admin_40": "问题详情",
    "admin_41": "用户协议",
    "admin_42": "分成汇总",
  },
  "common": {
    "cancel": "取消",
    "confirm": "确定",
    "edit": "编辑",
    "delete": "删除",
    "noData": "暂无数据",
    "back": "返回",
    "success": "操作成功",
    "failed": "操作失败",
    "noMore": "没有更多了",
    "search": "搜索",
    "tip": "提示",
    "submit": "提交",
    "add": "新增"
  }
};
